<template>
  <section>
    <social-header title="商品详情"></social-header>
    <share v-bind:title="product.name" v-bind:link="product.sharedUrl" v-bind:imgUrl="product.img" v-bind:desc="product.remark" v-bind:type="product.activityType" v-bind:show="isShowShareWindow" v-bind:platformActivityId="product.id" v-bind:originalImg="true"></share>
    <!--首页轮播图-->
    <div class="index-banner">
      <ul>
        <li><img :src="topImage" alt=""></li>
      </ul>
    </div>
    <!--首页轮播图-->
    <!--商品详情-->
    <div class="product-detail">
      <div class="product-detail-name">{{product.name}}</div>
      <ul class="clearfix">
        <li>服务费：
          <span class="font-orange">¥{{product.agentCommission}}元</span>（预计）</li>
        <li>售价：
          <span class="font-black">¥{{product.promotionPrice}}元</span>
        </li>
      </ul>
    </div>
    <!--商品详情-->
    <!--活动说明-->
    <div class="act-detail-intro" v-show="product.activityDetail">
      <div class="dlr-title">
        <span>活动规则</span>
      </div>
      <div class="act-detail-role" v-html="product.activityDetail">

      </div>
    </div>
    <!--活动说明-->
    <!--分享操作说明-->
    <div class="act-detail-share">
      <div class="dlr-title">
        <span>分享操作说明</span>
      </div>
      <div class="act-detail-img">
        <img src="../../static/img/act-detail-share.png" alt="">
      </div>
    </div>
    <!--分享操作说明-->
    <!--底部按钮-->
    <div class="act-detail-btn-bak"></div>
    <div class="second-bottom" v-stat:click="{name:'share_product'}">
      <a href="javascript:;" title="" v-on:click="isShowShareWindow=!isShowShareWindow">分享赚钱</a>
      <a v-bind:href="product.sharedUrl" title="" v-stat:click="{name:'oneself_buy'}">自己购买享优惠</a>
    </div>
    <!--底部按钮-->
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
  </section>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'
import Share from '../../components/share.vue'
import Dialog from '../../plugins/dialog.js'

export default {
  name: 'ProductDetail',
  data: function () {
    return {
      isLoadingProduct: true,
      isShowShareWindow: false
    }
  },
  components: {
    SocialHeader,
    SocialDialog,
    Share
  },
  created: function () {
    var current = this
    current.cheackUserAccountState()
    current.isLoadingProduct = true
    const platformActivityId = this.$route.params.productId
    var param = { platformActivityId: platformActivityId, pvAreaId: this.baseInfo.pvareaId }
    current.$store.dispatch('getProductDetail', param).then(function () {
      if (current.product.id === 0 || current.product.auditState !== 1) {
        Dialog.toast(
          {
            title: '该商品已下线',
            timeout: 2000,
            callback: function () { window.location = '#/activity/home' }
          }
        )
      }
      current.isLoadingProduct = false
    })
  },
  computed: {
    dialogShow () {
      return this.isLoadingProduct
    },
    ...mapGetters({
      userInfo: 'userInfo',
      product: 'product',
      baseInfo: 'baseInfo'
    }),
    topImage () {
      if (this.product) {
        // 优先读取白底小图
        return this.product.renderGraph || this.product.img
      }
      return ''
    }
  },
  methods: {
    hideShareWindow: function () {
      this.isShowShareWindow = false
    },
    cheackUserAccountState () {
      var self = this
      if (self.userInfo && self.userInfo.accountState === 2) {
        this.$router.replace('/account')
      }
    }
  },
  watch: {
    userInfo: function (val, oldVal) {
      if (val.accountState === 2) {
        this.$router.replace('/account')
      }
    }
  }
}
</script>
<style>
.act-detail-html img {
  width: 100%;
}
.act-detail-intro img {
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/productDetail.vue